<app-upsell-card
  [htmlTitle]="htmlTitle"
  [question]="question"
  [slug]="slug"
  (continueButtonPressed)="onContinueButtonPressed($event)"
  (optionSelected)="onOptionSelected($event)"
  [additionalFormsToValidate]="additionalFormsToValidate"
>
  <ng-content>
    <p class="mb-4">
      If you've had sex while experiencing an STI, the bacteria can transfer to your partner, increasing the risk of
      reinfection for both of you. This could disrupt your recovery, prolong your symptoms, and make treatment less
      effective. To help break this cycle, our specially formulated <strong>Penile Bacteria Wash</strong> is designed to
      target and eliminate these bacteria, reducing the chance of reinfection.
    </p>
    <p class="mb-4">
      Using this wash daily for 5 days helps ensure that
      <strong>you and your partner are both fully cleansed of any lingering bacteria</strong>, allowing you to complete
      your treatment with confidence and avoid setbacks.
    </p>
  </ng-content>
  <div bottomContent *ngIf="addressForm">
    <div class="mt-4">
      <app-address-inputs [form]="addressForm" [multiregion]="false"></app-address-inputs>
    </div>
  </div>
</app-upsell-card>
